// extracted by mini-css-extract-plugin
export default {"modalDocument":"styles_modalDocument__M1FbL","modalBody":"styles_modalBody__hL2Q6"};